// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuWithRemovedItems_root__138Qv","resetButton":"MenuWithRemovedItems_resetButton__28ckl"};